import { CSSProperties, FC, ReactNode } from 'react';
import Modal from 'react-modal';
import cx from 'classnames';

import { SvgIcon } from '@/components/SvgIcon';

import styles from './ModalDefault.module.sass';

const modalStyles = {
  content: {
    inset: 0,
    border: 'none',
    backgroundColor: 'transparent',
    pointerEvents: 'none',
  } as CSSProperties,
};

export interface ModalDefaultProps {
  isOpen: boolean;
  title?: string | null;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClose: () => void;
}

const ModalDefault: FC<ModalDefaultProps> = ({
  isOpen,
  title,
  children,
  actions,
  className,
  style,
  onClose,
}) => {
  const classes = cx(styles.modal, className);

  return (
    <Modal
      isOpen={isOpen}
      className="modal-content"
      bodyOpenClassName={styles.bodyLock}
      overlayClassName="modal-overlay modal-overlay--black"
      ariaHideApp={false}
      style={modalStyles}
      onRequestClose={onClose}
    >
      <div className={classes} style={style}>
        {title && <div className={styles.title}>{title}</div>}
        {children}
        {actions && <div className={styles.actions}>{actions}</div>}
        <button type="button" className={styles.close} onClick={onClose}>
          <SvgIcon name="x" />
        </button>
      </div>
    </Modal>
  );
};

export default ModalDefault;
